import { render, staticRenderFns } from "./Brandc.vue?vue&type=template&id=e98ca022&scoped=true&"
import script from "./Brandc.vue?vue&type=script&lang=js&"
export * from "./Brandc.vue?vue&type=script&lang=js&"
import style0 from "./Brandc.vue?vue&type=style&index=0&id=e98ca022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98ca022",
  null
  
)

export default component.exports